import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  typeIcon: {
    marginRight: 16,
    alignItems: 'center'
  },
  notification: {
    flexWrap: 'nowrap',
    height: 56,
    display: 'flex',
    borderRadius: 8,
    width: '100%',
    alignItems: 'center',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    paddingLeft: 16,
    paddingRight: 16,
    transition: 'background-color 100ms linear',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
      '& .MuiChip-root': {
        backgroundColor: theme.palette.divider
      }
    }
  },
  name: {
    flexGrow: 1,
    width: 179,
    alignItems: 'center'
  },
  created: {
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center'
  },
  headers: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiTypography-root': {
      alignItems: 'center'
    }
  },
  title: {
    '&.unread': {
      fontWeight: 600
    }
  },
  fullWidth: {
    width: '85%'
  }
}))

export default useStyles
